import { render, staticRenderFns } from "./CargoClause.vue?vue&type=template&id=83c60a6a&"
import script from "./CargoClause.vue?vue&type=script&lang=js&"
export * from "./CargoClause.vue?vue&type=script&lang=js&"
import style0 from "./CargoClause.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoClause.vue"
export default component.exports